<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <div class="card main-card">
            <div class="card-body">
              <!-- Search -->
              <div class="search-section">
                <div class="row align-items-center row-gap-2">
                  <div class="col-xl-5">
                    <div class="row align-items-center">
                      <div class="col-md-6">
                        <div class="form-wrap icon-form mb-0 info-container">
                          <span class="form-icon"><i class="ti ti-search"></i></span>
                          <input type="text" class="form-control" placeholder="Search opportunity by name / number"
                            v-model="searchOppQuery" />
                          <i class="ti ti-info-circle info-icon" data-bs-toggle="tooltip" data-bs-placement="top"
                            title="Search Opportunity number, Description, Comment, Organisation Name"></i>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <user-filters :from="'opportunity'" @filterData="searchOpportunities"></user-filters>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-7">
                    <div class="export-list">
                      <ul>
                        <li>
                          <div class="form-wrap mb-0">
                            <label class="col-form-label filter-lable w-100 text-start">Opp Type </label>
                            <Field as="select" name="opp_type" class="form-select py-2" v-model="filters.opp_type"
                              @change="oppTypeFilter">
                              <option value="">All</option>
                              <option v-for="res in options.opp_type" :key="res.value" :value="res.value">
                                {{ res.text }}
                              </option>
                            </Field>
                          </div>
                        </li>
                        <li class="">
                          <div class="form-wrap mb-0">
                            <label class="col-form-label filter-lable w-100 text-start">CED Range</label>
                            <select class="form-select py-2" v-model="isActive" @change="toggleFilter">
                              <option value="All">All</option>
                              <option value="within_365_or_blank">Blank or LT 365</option>
                              <option value="greater_than_365">Greater than 365</option>
                            </select>
                          </div>
                        </li>

                        <li class="">
                        <div class="form-wrap mb-0">
                          <label class="col-form-label filter-lable w-100 text-start">Next Update Latest</label>
                          <select class="form-select py-2" v-model="nextUpdateFilter" @change="applyNextUpdateFilter">
                            <option value="all">All</option>
                            <option value="current">Current</option>
                            <option value="future">Future</option>
                          </select>
                        </div>
                      </li>


                        <li class="days-filters-row mb-0 mt-1">
                          <div class="filter-set-view toggle-filter" ref="dropdown">
                            <div class="filter-set-head filter-btn">
                              <button @click.prevent="toggleAccordion" class="btn btn-light toggle-btn"><i
                                  class="ti ti-list-tree me-2"></i>Contents</button>
                              <div class="accordion filter-drop-down" id="columnAccordion" v-if="showAccordion">
                                <div class="filter-set-content">
                                  <div class="filter-set-contents accordion-collapse collapse show" id="columnCollapse"
                                    data-bs-parent="#columnAccordion">
                                    <div class="filter-content-list">
                                      <div class="form-wrap icon-form">
                                        <span class="form-icon"><i class="ti ti-search"></i></span>
                                        <input type="text" class="form-control" placeholder="Search Columns"
                                          v-model="searchTerm" />
                                      </div>
                                      <ul>
                                        <li v-for="colName in filteredColumnOptions" :key="colName.value">
                                          <div class="filter-checks">
                                            <label class="checkboxs"
                                              :class="{ 'disabled-label': selectedColumns.value.length === 2 && selectedColumns.value.includes(colName.value) }"
                                              @click.prevent="handleColumnSelection(colName.value)">
                                              <input type="checkbox" class="disabled-checkbox"
                                                :id="'checkbox-' + colName.value"
                                                :checked="selectedColumns.value.includes(colName.value)"
                                                :disabled="selectedColumns.value.length === 2 && selectedColumns.value.includes(colName.value)"
                                                @click.stop />
                                              <span class="checkmarks"></span>
                                            </label>
                                          </div>
                                          <div class="collapse-inside-text">
                                            <h5 :for="'checkbox-' + colName.value"
                                              @click="handleColumnSelection(colName.value)"
                                              :class="{ 'disabled-label': selectedColumns.value.length === 2 && selectedColumns.value.includes(colName.value) }">
                                              {{ colName.label }}
                                            </h5>
                                          </div>
                                        </li>

                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li class="mb-0 mt-1">
                          <div class="view-icons">
                            <router-link to="/crm/meter-opportunities-kanban"><i
                                class="ti ti-layout-kanban"></i></router-link>
                            <router-link to="/crm/meter-opportunities-list" class="active"><i
                                class="ti ti-list-tree"></i></router-link>
                          </div>
                        </li>
                        <li class="mb-0">
                          <div class="form-sorts dropdown">
                            <a href="javascript:void(0);" data-bs-toggle="dropdown" data-bs-auto-close="outside">
                              <i class="ti ti-filter-share"></i>Filter
                            </a>
                            <div class="filter-dropdown-menu dropdown-menu dropdown-menu-xl-end">
                              <div class="filter-set-view">
                                <div class="filter-set-head">
                                  <h4><i class="ti ti-filter-share"></i>Filter</h4>
                                </div>
                                <div class="filter-content-list mb-2">
                                  <label for="search-status" class="mb-2">Next update Start Date - Next update End
                                    Date</label>
                                  <date-time-picker v-model="date" range multi-calendars format="yyyy-MM-dd"
                                    :enable-time-picker="false" />
                                </div>
                                <div class="filter-content-list mb-4">
                                  <label for="search-status" class="mb-2">Pipeline</label>
                                  <!-- <Field as="select" name="pipeline" class="form-select" v-model="pipeline">
                                    <option value="">-----Select-----</option>
                                    <option v-for="res in pipelineLevels" :key="res.id" :value="res.id">
                                      {{ res.name }}
                                    </option>
                                  </Field> -->
                              <multiselect v-model="selectedPipelines" :options="pipelineLevels"
                                track-by="id" label="name"
                                :multiple="true"
                                placeholder="Select..." />
                                </div>
                                <div class="filter-reset-btns">
                                  <div class="row">
                                    <div class="col-6">
                                      <a href="javascript:void(0);" class="btn btn-light"
                                        @click="resetFilters">Reset</a>
                                    </div>
                                    <div class="col-6">
                                      <a href="javascript:void(0);" class="btn btn-primary"
                                        @click="applyFilters">Filter</a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li class="mb-0 mt-2 mt-md-0">
                          <router-link to="/crm/create-meter-opportunity" title="Add Opportunity"
                            class="btn btn-primary"><i class="ti ti-square-rounded-plus"></i>Add</router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Search -->

              <!-- Contact List -->
              <div class="table-responsive custom-table">
                <meter-opportunities-table :search-opp-query="searchOppQuery" :filterData="filters" :moduleId="moduleId"
                  :selectedColumns="selectedColumns" :columnOptions="columnOptions" :date_range="isActive" :date="date"
                  :pipeline="pipeline"  :next_update="nextUpdateFilter" ref="oppTable"></meter-opportunities-table>
              </div>
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div class="datatable-length"></div>
                </div>
                <div class="col-md-6">
                  <div class="datatable-paginate"></div>
                </div>
              </div>
              <!-- /Contact List -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { onBeforeUnmount, ref, watch } from "vue";
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { Form, Field, ErrorMessage } from "vee-validate";
import Multiselect from 'vue-multiselect';

export default {
  data() {
    return {
      title: "Meter Opportunities",
    };
  },
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup() {
    const store = useStore();
    const searchOppQuery = ref(""); // Example: For holding search query input
    const oppTable = ref(null);
    const date = ref(null);
    // const pipeline = ref([]);
    const isActive = ref(localStorage.getItem('opp365') || "All");
    const nextUpdateFilter = ref(localStorage.getItem('next_update_latest') || "current");
    const filters = ref({
      opp_type: localStorage.getItem('oppType') || ""
    })

    const selectedPipelines = ref([]); // stores full objects
    const pipeline = computed(() => selectedPipelines.value.map(p => p.id));

    const showAccordion = ref(false);
    const searchTerm = ref("");
    const selectedColumns = ref([]);
    const dropdown = ref(null);

    const moduleId = ref(null)

    const columnOptions = ref([]);

    const toggleAccordion = () => {
      showAccordion.value = !showAccordion.value;
    };

    const handleColumnSelection = (value) => {
      if (selectedColumns.value.value.includes(value)) {
        selectedColumns.value.value = selectedColumns.value.value.filter(col => col !== value);
      } else {
        selectedColumns.value.value.push(value);
      }
    };

    const filteredColumnOptions = computed(() => {
      if (!searchTerm.value) return columnOptions.value.value;
      return columnOptions.value.value.filter(option =>
        option.label.toLowerCase().includes(searchTerm.value.toLowerCase())
      );
    });


    const handleClickOutside = (event) => {
      if (dropdown.value && !dropdown.value.contains(event.target)) {
        showAccordion.value = false;
      }
    };


    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
    });

    onBeforeUnmount(() => {
      document.removeEventListener("click", handleClickOutside);
    });

    // const date_range = ref('')
    const pipelineLevels = computed(
      () => store.getters["opportunity/getPipelineLevels"]
    );
    const options = computed(
      () => store.getters["opportunity/getoppDropdowns"]
    );
    const oppTypeFilter = () => {
      localStorage.setItem('oppType', filters.value.opp_type);
      setTimeout(() => {
        applyFilters();
      }, 0);
    }
    const searchOpportunities = (page = 1) => {
      if (oppTable.value) {
        oppTable.value.fetchOpportunities(page);
      }
    };

    const resetFilters = () => {
      date.value = null;
      selectedPipelines.value = []
      setTimeout(() => {
        applyFilters();
      }, 0);
    };

    const applyFilters = () => {
      searchOpportunities();
    };

     const applyNextUpdateFilter = () => {
      localStorage.setItem('next_update_latest', nextUpdateFilter.value);
      setTimeout(() => {
        applyFilters();
      }, 0);
    };
    const toggleFilter = () => {
      localStorage.setItem('opp365', isActive.value);
      setTimeout(() => {
        applyFilters();
      }, 0);
    };
    // Watch search input
    let debounceTimeout;

    watch(searchOppQuery, (newQuery) => {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(async () => {
        await searchOpportunities(1);
      }, 500); // wait 300ms after typing stops
    });

    onMounted(async () => {
      await store.dispatch("opportunity/fetchPipelines");
      const data = await store.dispatch('opportunity/fetchOpportunityOptions');
      if (data?.module_id?.[0]?.id) {
        moduleId.value = data.module_id[0].id;
      }
    });

    return {
      pipelineLevels,
      date,
      resetFilters,
      options,
      filters,
      searchOpportunities,
      oppTypeFilter,
      applyFilters,
      searchOppQuery,
      pipeline,
      oppTable,
      isActive,
      toggleFilter,
      // date_range
      showAccordion,
      searchTerm,
      selectedColumns,
      columnOptions,
      toggleAccordion,
      handleColumnSelection,
      filteredColumnOptions,
      dropdown,
      handleClickOutside,
      moduleId,
      nextUpdateFilter,
      applyNextUpdateFilter,
      selectedPipelines
    };
  },
};
</script>
<!-- <style>
.custom-table {
  height: 850px;
  overflow-x: hidden;
}

.filter-btn {
  position: relative;
}

.filter-drop-down {
  width: 350px;
  z-index: 9999;
  position: absolute;
  top: 90%;
  left: -160%;
}

.filter-set-contents .filter-content-list ul {
  max-height: 280px !important;
}

.toggle-btn {
  background-color: transparent !important;
  border: none !important;
  font-weight: 500 !important;
}

.disabled-checkbox {
  opacity: 0.6;
}

.disabled-label {
  cursor: not-allowed;
  pointer-events: none;
}
</style> -->